<script setup lang="ts">
import { SeoDescriptionProps } from "./SeoDescription.props"
defineProps<SeoDescriptionProps>()
</script>

<template>
  <section
    class="
      text_blocks-seo_description
      mt-4
      rounded
      px-4
      py-6
      md:mt-8
      md:px-6
      md:pt-8
      md:shadow-01
    "
  >
    <p v-if="subtitle" class="beaver uppercase">{{ subtitle }}</p>

    <p v-if="title" class="elephant-bold text-green-main mb-4 mt-2">
      {{ title }}
    </p>

    <UtilsMarkdown
      v-if="text"
      class="
        beaver
        markdown__link-underlined
        markdown__link-green-main
        markdown__link-hover-green-300
      "
      :content="text"
    />
  </section>
</template>
